<template>
  <div class="yc-body-main-wrapper full-height overflow-x-hidden" v-resize="onResize">
    <div class="d-flex" v-if="!focusContent">
      <v-navigation-drawer
          class="d-block d-lg-none navigation-drawer-mobile"
          width="80%"
          v-if="!desktop"
          v-model="navBarService.isOpen"
          style="max-width: 500px"
          app
      >
        <div class="h-full">
          <div class="fill-height table-of-contents overflow-x-hidden overflow-y-auto">
            <h2 class="txt-title text-uppercase pt-6">{{ 'Table of content' }}</h2>
            <section
                class="content pr-3"
                id="table-of-content">
            </section>
          </div>
        </div>
      </v-navigation-drawer>
      <div v-else>
        <div class="fullscreen fill-height table-of-contents overflow-x-hidden overflow-y-auto">
          <h2 class="txt-title text-uppercase pt-6">{{ 'Table of content' }}</h2>
          <section
              class="content pr-3"
              id="table-of-content">
          </section>
        </div>
      </div>
      <div>
        <div class="yc-container" >
          <div class="yc-content overflow-x-hidden mobile" id="scroll-content" ref="sectionForm">
            <div class="pl-8 pt-8 pr-4">
              <div>
                <div id="content">
                  <VueMarkdown
                      id="scrollTabsContainer"
                      class="scrollTabsContainer"
                      :source="someMarkdownText"
                      :toc="true"
                      :watches="sources"
                      :toc-first-level="2"
                      :toc-last-level="4"
                      :toc-anchor-link-symbol="''"
                      :toc-anchor-link-class="'v-list-active'"
                      @rendered="rendered"
                      :prerender="prerender"
                      :postrender="postrender"
                      toc-id="table-of-content"
                  ></VueMarkdown>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mx-auto d-flex" v-else>
      <v-card
          elevation="2"
          class="mx-auto my-12 pa-10"
          max-width="1100"
      >
        <VueMarkdown
            id="scrollTabsContainer1"
            class="scrollTabsContainer text-left"
            :source="someMarkdownText"
            :toc="true"
            :watches="sources"
            :toc-first-level="2"
            :toc-last-level="4"
            :toc-anchor-link-symbol="''"
            :toc-anchor-link-class="'v-list-active'"
            @rendered="rendered"
            :prerender="prerender"
            :postrender="postrender"
            toc-id="table-of-content"
        ></VueMarkdown>

      </v-card>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
import VueMarkdown from 'vue-markdown'
import MSuiteUserGuide from '@/views/user-guide/M-Suite-UserPortalandAgent-Guide.md';
import MSuiteTroubleshooting from '@/views/user-guide/M-Suite-Troubleshooting-Guide.md';
import MSuiteTroubleshootBaselineFix from '@/views/user-guide/M-Suite-Troubleshooting-Baseline-Fix.md';
import navBarService from "../../../services/navBarService";

export default Vue.extend({
  name: "UserGuide",
  components: {
    VueMarkdown,
  },
  data() {
    return {
      drawer: true,
      windowSize: {
        x: 0,
        y: 0,
      },
      loadingComplete: false,
      hiddenMenu: true,
      focusContent: false,
      navBarService,
      menus: [],
      contents: [],
      sources: ["source", "show", "toc"],
      someMarkdownText: '',
      sectionObserver: null,
      numberResult: 0,
      currentResult: 0,
    }
  },
  watch: {
    "$route": {
      async handler(router) {
        if (this.loadingComplete) {
          await this.activeMenu(router.hash, false, true)
        }
        this.$nextTick(() => {
          this.focusContent = !!(router && router.query && router.query.focusContent)
        })
      },
      deep: true,
      immediate: true
    },
  },
  computed: {
    desktop() {
      return this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl;
    }
  },
  mounted() {
    const vm = this
    this.$nextTick(async () => {
      await vm.onResize()
      await vm.renderHtml()
      if (vm.$route && vm.$route.hash) {
        await vm.activeMenu(vm.$route.hash, true)
      }
      vm.loadingComplete = true
      const sectionFormPage = document.getElementById("scroll-content");
      if (sectionFormPage) {
        sectionFormPage.addEventListener("scroll", () => {
          vm.onScroll()
        })
      }
    })
  },

  methods: {
    onResize() {

    },

    renderHtml() {
      this.someMarkdownText = MSuiteUserGuide + MSuiteTroubleshooting + MSuiteTroubleshootBaselineFix
    },

    onScroll() {
      const elements = document.querySelectorAll("#scroll-content h2, h3, h4")
      let current = "";
      const pageYOffsetForm = this.$refs.sectionForm.scrollTop;
      elements.forEach((el, index) => {
        const sectionTop = el.offsetTop;
        const sectionHeight = el.clientHeight;
        if (pageYOffsetForm >= sectionTop - sectionHeight / 2 ||
            (pageYOffsetForm ===
                this.$refs.sectionForm.scrollHeight -
                this.$refs.sectionForm.clientHeight &&
                index === el.length - 1)
        ) {
          current = el.getAttribute("id");
        }
      });
      if (current) {
        setTimeout(() => {
          location.hash = current
        })
      }
    },

    async activeMenu(hash, mount = false, changeUrl = false) {
      this.$nextTick(() => {
        const tableOfContent = document.querySelectorAll("section ul li");
        tableOfContent.forEach(li => {
          li.children[0].classList.remove('active')
          if (hash === li.children[0].getAttribute('href')) {
            li.children[0].classList.add('active')
            let hashToString = decodeURIComponent(hash)
            if (hashToString) {
              hashToString = hashToString.replace('#', '')
              setTimeout(() => {
                const element = document.getElementById(hashToString)
                const offsetTop = element.offsetTop
                const content = document.getElementById("scroll-content")
                if (!changeUrl) {
                  if (!mount) {
                    if (offsetTop && content) {
                      content.scroll({
                        top: offsetTop,
                        behavior: 'smooth'
                      })
                    }
                  } else {
                    this.onScrollTableOfContent(hash)
                    content.scroll({
                      top: element.offsetTop,
                    })
                  }
                }
              }, 250)
            }
          }
        });
      })
    },

    onScrollTableOfContent(hash) {
      const listEl = document.querySelectorAll('#table-of-content ul li a')
      for (const el of listEl) {
        if (el.getAttribute('href') === hash) {
          el.scrollIntoView({block: "center", inline: "nearest"})
          break;
        }
      }
    },

    rendered(html) {
      const htmlObject = document.createElement('div');
      htmlObject.innerHTML = html;
    },

    prerender(html) {
      return html;
    },

    postrender(html) {
      if (!this.focusContent) {
        return html
      }
      const hash = this.$route.hash
      let hashToString = decodeURIComponent(hash)
      const htmlObject = document.createElement('div');
      htmlObject.innerHTML = html;
      const childrenEls = htmlObject.children;
      let stringElement = ''

      if (hashToString) {
        hashToString = hashToString.replace('#', '')
      }
      let oldKey = ''
      for (const childrenEl of childrenEls) {

        if (childrenEl.id && childrenEl.id === hashToString) {
          oldKey = childrenEl.id
          stringElement += childrenEl.outerHTML
        }

        if (childrenEl.id) {
          oldKey = childrenEl.id
        }

        if (!childrenEl.id && oldKey === hashToString) {
          stringElement += childrenEl.outerHTML
        }

      }
      if (!stringElement) {
        return html
      }
      return stringElement;
    },

    goToContact() {
      this.$router.push({path: '/user-guide/contact'})
    }
  },

})
</script>

<style lang="scss">
.text-warning {
  font-weight: bold !important;
}

#scrollTabsContainer1 {
  img {
    max-width: 100%;
    margin-bottom: 24px;
    margin-top: 24px;
  }

  h1, h2, h3 {
    font-size: 25px;
    margin-bottom: 24px;
  }
}

#scrollTabsContainer {
  img {
    max-width: 100%;
  }

  h1, h2, h3, h4 {
    font-size: 24px;
    margin-bottom: 24px;
  }
}
#scrollTabsContainer1 {
  img {
    max-width: 100%;
    margin-bottom: 24px;
    margin-top: 24px;
  }

  h1, h2, h3, h4 {
    font-size: 24px!important;
    margin-bottom: 24px;
  }
}

.table {
  padding: 20px;
  border: 1px solid black;
  border-collapse: collapse;

  th, td {
    padding: 20px;
    border: 1px solid black;
    border-collapse: collapse;
  }
}
</style>
